module.exports = __webpack_public_path__ + "static/img/female-bg-pt.278beba2.png";